import { UiVariant } from '@ui/theme/variants'
import { colors } from '@ui/colors'

export type SectionRowVariant = Exclude<UiVariant, 'neutral' | 'warning'>

type SectionRowColors = {
  icon?: string
  title?: string
  desc?: string
  info?: string
  requiredIndicator?: string
}

export const borderRadius = 24

export const colorsVariant: Record<SectionRowVariant, SectionRowColors> = {
  default: {
    icon: colors.text,
    title: colors.text,
    desc: colors.black50,
    info: colors.black50,
    requiredIndicator: colors.red[600],
  },
  disabled: {
    icon: colors.neutral[300],
    title: colors.neutral[300],
    desc: colors.neutral[300],
    info: colors.neutral[300],
    requiredIndicator: colors.text0,
  },
  active: {
    icon: colors.green[600],
    title: colors.text,
    desc: colors.black50,
    info: colors.green[600],
    requiredIndicator: colors.text,
  },
  attention: {
    icon: colors.orange[500],
    title: colors.text,
    desc: colors.black50,
    info: colors.orange[500],
    requiredIndicator: colors.text,
  },
  success: {
    icon: colors.green[600],
    title: colors.text,
    desc: colors.black50,
    info: colors.green[600],
    requiredIndicator: colors.text,
  },
  danger: {
    icon: colors.red[600],
    title: colors.text,
    desc: colors.black50,
    info: colors.red[600],
    requiredIndicator: colors.text,
  },
} as const

export const borderWidthVariant: Record<SectionRowVariant, number> = {
  default: 1,
  disabled: 1,
  active: 2,
  attention: 2,
  success: 2,
  danger: 2,
}
